import {BaseState} from "../../BaseState";
import {AdaptiveType} from "../UrlsState";

export enum CacheClearJobStatus {
  processing = "processing",
  idle = "idle",
  completed = "completed"
}

export default interface DeleteUrlsState extends BaseState {
  readonly like?: string;
  readonly regex?: string;
  readonly adaptiveType: AdaptiveType;
  readonly cacheClearJobStatus: CacheClearJobStatus;
}
